import { AxiosInstance } from "axios";
import { User, VenueResponse } from "../types";

export async function getUserData(api: AxiosInstance) {
  return await api.get<User>("api/users/v1/users/me/");
}

export async function getVenueData(api: AxiosInstance) {
  return await api.get<VenueResponse>("api/the-hub-api/v1/venues/");
}
